import { render, staticRenderFns } from "./ReportIssueForm.vue?vue&type=template&id=a29e1f84&"
import script from "./ReportIssueForm.vue?vue&type=script&lang=js&"
export * from "./ReportIssueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports